import { Pipe, PipeTransform, inject } from '@angular/core';
import {
  ActivityCategoryReference,
  TranslateActivityCategoryService,
} from './translate-activity-category.service';

@Pipe({
  name: 'translateActivityCategory',
  pure: false,
})
export class TranslateActivityCategoryPipe implements PipeTransform {
  private readonly translateActivityCategoryService = inject(
    TranslateActivityCategoryService,
  );

  transform(value: ActivityCategoryReference): string {
    return this.translateActivityCategoryService.resolve(value);
  }
}
